'use client';

import { useJobs } from '@gate-js/react';

export default function GateJobListEndOfListWrapper({ children }) {
	const { jobs, limit, loading } = useJobs();

	return (!loading && (!limit || limit >= jobs.length)) ? (
		children
	) : null;
}
